<template>
  <!-- <div style="margin-bottom:70px"> -->
  <!-- <div class="search-line">
      <div class="search-form-group">
        <label class="group-label">显示周期</label>
        <el-radio-group v-model="period" size="medium" @change="periodChange">
          <el-radio-button label="0">按日</el-radio-button>
          <el-radio-button label="1">按周</el-radio-button>
          <el-radio-button label="2">按月</el-radio-button>
        </el-radio-group>
      </div>
    </div> -->

  <div class="digitizationCon">
    <el-button class="goBack" @click="goBack">返回</el-button>
    <div class="digNav">
      <span class="navTitle">设备数字化管理</span>

      <div
        class="navType_1"
        v-for="(item, index) in typeList"
        :key="index"
        :class="[navType == item.type ? 'navActive' : '']"
        @click="navTypeChange(item.type)"
      >
        {{ item.name }}
        <div class="navLine" v-show="navType == item.type"></div>
      </div>
      <!-- <div
        class="navType_2"
        :class="[navType == 1 ? 'navActive' : '']"
        @click="navTypeChange(1)"
      >
        压路机
        <div class="navLine" v-show="navType == 1"></div>
      </div>
      <div
        class="navType_3"
        :class="[navType == 35 ? 'navActive' : '']"
        @click="navTypeChange(35)"
      >
        铣刨机
        <div class="navLine" v-show="navType == 35"></div>
      </div> -->
    </div>

    <div class="pieInfoCon">
      <div class="pieInfoItem">
        <div id="infoItemChart_1" class="infoItemChart"></div>
        <div class="infoItemNum">
          <div class="itemNumShow" v-for="(item, index) in list_1" :key="index">
            <div class="showCon1">{{ item.name }}：</div>
            <div class="showCon2">
              {{ item.value }}
              <span style="font-size: 16px; color: #595959">台</span>
            </div>
          </div>
        </div>
      </div>
      <div class="pieInfoItem">
        <div id="infoItemChart_2" class="infoItemChart"></div>
        <div class="infoItemNum">
          <div class="itemNumShow" v-for="(item, index) in list_2" :key="index">
            <div class="showCon1">{{ item.name }}：</div>
            <div class="showCon2">
              {{ item.value }}
              <span style="font-size: 16px; color: #595959">台</span>
            </div>
          </div>
        </div>
      </div>
      <div class="pieInfoItem">
        <div id="infoItemChart_3" class="infoItemChart"></div>
        <div class="infoItemNum">
          <div class="itemNumShow" v-for="(item, index) in list_3" :key="index">
            <div class="showCon1">{{ item.name }}：</div>
            <div class="showCon2">
              {{ item.value }}
              <span style="font-size: 16px; color: #595959">台</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="tabTypeCon">
      <div
        class="tabTypeItem tabTypeItem_1"
        :class="[tabType == 0 ? 'tabTypeActive' : '']"
      ></div>
      <div
        class="tabTypeItem tabTypeItem_2"
        :class="[tabType == 1 ? 'tabTypeActive' : '']"
      ></div>
      <div
        class="tabTypeItem tabTypeItem_3"
        :class="[tabType == 2 ? 'tabTypeActive' : '']"
      ></div>
      <div
        class="tabTypeText_1"
        :class="[tabType == 0 ? 'tabTypeTextActive' : '']"
        @click="tabTypeChange(0, '油耗')"
      >
        油耗
      </div>
      <div
        class="tabTypeText_2"
        :class="[tabType == 1 ? 'tabTypeTextActive' : '']"
        @click="tabTypeChange(1, '开机时长')"
      >
        开机时长
      </div>
      <div
        class="tabTypeText_3"
        :class="[tabType == 2 ? 'tabTypeTextActive' : '']"
        @click="tabTypeChange(2, '行驶里程')"
      >
        行驶里程
      </div>
    </div>

    <div class="orderCon">
      <div class="line"></div>
      <div class="lineText">{{ typeChangeText }}排行榜</div>
      <!-- <span class="text_1">显示周期</span>
        <span class="text_2">排序</span> -->
      <div class="sortCon2" v-if="sortCode == 1" @click="sortChange(2)"></div>
      <div class="sortCon1" v-if="sortCode == 2" @click="sortChange(1)"></div>
      <div class="search-form-group">
        <label class="group-label">显示周期</label>
        <el-radio-group v-model="period" size="medium" @change="periodChange">
          <el-radio-button label="0">本日</el-radio-button>
          <el-radio-button label="1">本周</el-radio-button>
          <el-radio-button label="2">本月</el-radio-button>
        </el-radio-group>
      </div>
      <div class="search-form-group-order" v-if="tabType != 2">
        <label class="group-label">排序</label>
        <el-radio-group
          v-model="periodOrder"
          size="medium"
          @change="periodChangeOrder"
        >
          <el-radio-button label="0">{{
            tabType == 0 ? "总油耗" : "开机时长"
          }}</el-radio-button>
          <el-radio-button label="1">{{
            tabType == 0 ? "每小时油耗" : "利用率"
          }}</el-radio-button>
        </el-radio-group>
      </div>
      <div class="orderChart" id="orderChart"></div>
      <div class="warnCon">
        <div class="line"></div>
        <div class="lineText">{{ typeChangeText }}异常分析</div>
        <div class="warnItem">
          <div
            class="warnItemInfo"
            v-for="(item, index) in dataList"
            :key="index"
          >
            <span class="warnName">{{ item.equipName }}</span>
            <span class="warnInfo"
              >{{ item.date }} {{ warnObj[item.warningType] }}</span
            >
            <span class="lookMore" @click="lookMore(item.equipCode)"
              >查看更多</span
            >
            <i class="right"></i>
          </div>
        </div>
        <el-pageCover
          class="pageBlock"
          :pageMsg="pageMsg"
          @sizeChange="pageSizeChange"
          @currentChange="currentPageChange"
        ></el-pageCover>
      </div>
    </div>
    <div class="hourCon">
      <div class="line"></div>
      <div class="lineText">每日{{ typeChangeText }}</div>
      <span class="text_1">日期</span>
      <el-date-picker
        class="dateCheckCon"
        v-model="value2"
        type="daterange"
        align="left"
        unlink-panels
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        :picker-options="pickerOptions"
      >
      </el-date-picker>
      <div class="searchCon" @click="getDayInfo">确定</div>
      <span class="text_2">选择型号</span>
      <el-select @change="typeChange" v-model="selectType" placeholder="请选择型号" class="dateSelectCon">
        <el-option
          v-for="item in equipTypeList"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        ></el-option>
      </el-select>
      <div class="hourEquipChart" id="hourEquipChart" v-if="false"></div>
      <div class="hourEquipTypeChart" id="hourEquipTypeChart" v-loading="loading"
    element-loading-text="拼命加载中"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"></div>
      <!-- <div class="fxCon" v-if="false">
        <div class="line"></div>
        <div class="lineText">{{ typeChangeText }}分析</div>
        <div class="dayInfoContent">
          <DayInfo
            :unit="unit"
            :setAnalysis="setAnalysisA"
            :typeChangeText="typeChangeText"
          ></DayInfo>
        </div>
      </div> -->

      <div class="fxConT" >
        <div class="line"></div>
        <div class="lineText">{{ typeChangeText }}分析</div>
        <div class="dayInfoContent">
          <DayInfo
            :unit="unit"
            :setAnalysis="setAnalysisB"
            :typeChangeText="typeChangeText"
          ></DayInfo>
        </div>
      </div>
    </div>
    

    <el-dialog
      :title="checkDate + ' ' + typeChangeText+ '分析'"
      :visible.sync="warnShow"
      width="960px"
      >
      <div class="warnBox" ref="warnBox">
        <img src="../../images/icon/loading.gif" alt="" class="gifShow" v-if="gifShow">
        <!-- <span class="warnTitle"></span> -->
        <!-- <span class="closeShow" @click="closeBox">×</span> -->
        <div class="boxLeft" ref="boxLeft" :style="{ height: scrollerHeight }">
          <div id="warnChart" class="warnChart"></div>
        </div>
        <div class="boxRight">
          <div
            class="warnInfoCon"
            v-for="(item, index) in warnBoxList"
            :key="index"
          >
            <div class="numShow_1" v-if="index == 0 && selectType == ''"></div>
            <div class="numShow_2" v-if="index != 0"></div>
            <div class="warnInfoTitle" v-if="selectType == ''">
              排名第{{ index + 1 }}: {{ item.model }}
            </div>
            <div class="warnInfoItem">
              <div
                class="infoItem"
                v-for="(i, n) in item.analysisResult"
                :key="n"
              >
                <div class="circle_1" v-if="index == 0"></div>
                <div class="circle_2" v-if="index != 0"></div>
                {{ i.content }}<span class="clickToMore" @click="goToEquipInfo(i.equipCode,i.typeName)">点击查看更多</span>
              </div>
            </div>
          </div>
        </div>
        <div style="clear: both"></div>
      </div>
      
    </el-dialog>
    
  </div>
  <!-- </div> -->
</template>

<script>
import {
  getEquipCountStatistics,
  getRank,
  recordWarningAnalysis as fetchDtList,
  getDay,
  getDayAnalysis,
  getEquipCountByType,
  getDayWarningAnalysisDetails,
  getEquipStatisticByModel
  // getEquipTypeList
} from "../../utils/api";
// import ChartPanel from "../../components/chart/panel1";
import roleMixin from "../../utils/roleMixin";
import mixinList from "../../utils/mixinList";
import { dateFormat, dateTransfor1, dateTransfor } from "../../utils/commons";
import ElPageCover from "../../components/overall/ElPageCover";
import DayInfo from "./part/dayInfo";
export default {
  name: "app",
  mixins: [roleMixin, mixinList],
  data() {
    return {
      dialogVisible:false,
      sortCode: 1,
      sortList: [],
      getDayList: [],
      gifShow: true,
      warnShow: false,
      warnBoxList: [],
      checkDate: "",
      scrollerHeight: 0,
      typeChangeText: "油耗",
      unit: "L",
      typeName: "摊铺机",
      value2: "",
      tabType: 0,
      pageMsg: {
        pageSize: 5,
        pageNo: 1,
        totalRecords: 10,
      },
      search: {
        pageSize: 5,
        pageNo: 1,
        tab: 0,
        type: 2,
      },
      arrowList: [
        {
          name: "设备中心",
          path: "/transfer/equipmentCenter",
        },
        {
          name: "设备数字化管理",
          path: "/transfer/digitization",
        },
      ],

      list_1: [],
      list_2: [],
      list_3: [],

      config1: {
        title: "",
        circleConfig: [
          {
            id: this.uuid(),
            title: "今日摊铺里程",
            color: "#4facf9",
            content: "0",
            percent: "无数据",
            unit: "",
            name1: "今日摊铺里程",
            name2: "平均摊铺里程",
          },
          {
            id: this.uuid(),
            title: "今日碾压里程",
            color: "#f6c018",
            content: "0",
            percent: "无数据",
            unit: "",
            name1: "今日碾压里程",
            name2: "平均碾压里程",
          },
        ],
      },
      config2: {
        title: "",
        circleConfig: [
          {
            id: this.uuid(),
            title: "今日摊铺机油耗",
            color: "#4facf9",
            content: "0",
            percent: "无数据",
            unit: "",
            name1: "今日摊铺机油耗",
            name2: "平均摊铺机油耗",
          },
          {
            id: this.uuid(),
            title: "今日压路机油耗",
            color: "#f6c018",
            content: "0",
            percent: "无数据",
            unit: "",
            name1: "今日压路机油耗",
            name2: "平均压路机油耗",
          },
        ],
      },
      navType: 2,
      period: 2,
      periodOrder: 0,
      // textValue
      orderList: [
        { name: "1号摊铺机", allOil: 80, hourOil: 5 },
        { name: "2号摊铺机", allOil: 70, hourOil: 8 },
        { name: "3号摊铺机", allOil: 90, hourOil: 8 },
        { name: "4号摊铺机", allOil: 100, hourOil: 7 },
        { name: "5号摊铺机", allOil: 50, hourOil: 9 },
        { name: "6号摊铺机", allOil: 60, hourOil: 5 },
      ],
      orderChart: "",
      warnList: [
        { name: "1号摊铺机", date: "1月1日", typeName: "总油耗过高！" },
        { name: "1号摊铺机", date: "1月1日", typeName: "总油耗过高！" },
        { name: "1号摊铺机", date: "1月1日", typeName: "总油耗过高！" },
        { name: "1号摊铺机", date: "1月1日", typeName: "总油耗过高！" },
        { name: "1号摊铺机", date: "1月1日", typeName: "总油耗过高！" },
      ],
      hourEquipChart: "",
      hourEquipTypeChart: "",
      hourList: [
        {
          name: "摊铺机",
          value: [
            { date: "4/16", count: 5 },
            { date: "4/17", count: 6 },
            { date: "4/18", count: 3 },
            { date: "4/19", count: 3 },
            { date: "4/20", count: 3 },
            { date: "4/21", count: 3 },
            { date: "4/22", count: 3 },
            { date: "4/23", count: 3 },
            { date: "4/24", count: 3 },
            { date: "4/25", count: 3 },
            { date: "4/26", count: 3 },
            { date: "4/27", count: 3 },
          ],
        },
        {
          name: "无人摊铺机",
          value: [
            { date: "4/16", count: 5 },
            { date: "4/17", count: 6 },
            { date: "4/18", count: 3 },
            { date: "4/19", count: 3 },
            { date: "4/20", count: 3 },
            { date: "4/21", count: 3 },
            { date: "4/22", count: 3 },
            { date: "4/23", count: 5 },
            { date: "4/24", count: 3 },
            { date: "4/25", count: 3 },
            { date: "4/26", count: 3 },
            { date: "4/27", count: 3 },
          ],
        },
      ],
      setColorList: [
        "#597EF7",
        "#FFA940",
        "#73D13D",
        "#FFC53D",
        "#36CFC9",
        "#FFEC3D",
        "#40A9FF",
        "#BAE637",
      ],
      warnObj: {
        0: "未知",
        1: "总值过高",
        2: "每小时值过高",
        3: "每小时值过低",
        4: "总值过低",
      },
      fxSetObj: {
        total: {
          maxNum: 10,
          maxDate: "4月28日",
          minNum: 5,
          minDate: "4月20日",
          avgNum: 8,
          bzc: 3,
          bzcT: "波动频繁",
        },
      },
      startTime: "",
      endTime: "",
      setAnalysisA: "",
      setAnalysisB: "",
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      equipTypeList: [],
      loading: true,
      selectType: '',
      typeList: [],
      dateWarningMap: ''
    };
  },
  computed: {},
  created() {},
  mounted() {
    this.$store.commit("setArrowList", this.arrowList);
    this.value2 = [dateTransfor1(), dateTransfor()];
    let corpCode = localStorage.getItem("corpCode");
    // getEquipTypeList({ pageSize: 100 }).then((res) => {
    //   //console.log(res)
    //   let list = res.data.content.list;
    //   for(let i=0;i<list.length;i++){
    //     this.equipTypeList[list[i].id] = list[i].name
    //   }
    // });
    this.tabType = this.$route.params.code || '0'
    this.navType = this.$route.params.type || '1'
    this.typeChangeText = this.tabType == 0?'油耗':(this.tabType == 1?'开机时长':'行驶里程')
    getEquipCountByType({ corpCode: corpCode }).then((res) => {
      console.log(res);
      this.typeList = res.data.content;
      // this.navType = res.data.content[0].type;
      this.apiIsA(corpCode, this.navType);
      this.apiIsB(this.tabType, this.navType, 0, this.period);
      // this.apiIsC(
      //   this.tabType,
      //   this.navType,
      //   this.startTime,
      //   this.endTime,
      //   "equip_detail_type"
      // );
      this.apiIsC(
        this.tabType,
        this.navType,
        this.startTime,
        this.endTime,
        "equip_model"
      );
      // this.apiIsD(
      //   this.tabType,
      //   this.navType,
      //   this.startTime,
      //   this.endTime,
      //   "equip_detail_type"
      // );
      this.apiIsD(
        this.tabType,
        this.navType,
        this.startTime,
        this.endTime,
        "equip_model"
      );
      this.doSearch();
    });
    const echarts = require("echarts");
    this.hourEquipTypeChart = echarts.init(
          document.getElementById("hourEquipTypeChart")
        );
    let that = this

    this.hourEquipTypeChart.on("click", function (params) {
      that.gifShow = true
      console.log(params);
      that.warnShow = true;
      that.checkDate = params.name;
      getDayWarningAnalysisDetails({
        type: that.navType,
        tab: that.tabType,
        date: params.name,
        model: that.selectType == ''?'':that.equipTypeList[that.selectType].name
      }).then((res) => {
        console.log(res);
        // let list = res.data.content.dataList
        // list[0].analysisResult[0] = '1号摊铺机，油耗100L，超出平均值20L (具体异常说明)，每小时油耗50L，超出平均值10L (具体异常说明)，'
        // list[0].analysisResult[1] = '1号摊铺机，油耗100L，超出平均值20L (具体异常说明)，每小时油耗50L，超出平均值10L (具体异常说明)，'
        that.warnBoxList = res.data.content.dataList;
        setTimeout(() => {
          // console.log(that.$refs.warnBox.offsetHeight)
          if(that.selectType == ''){
            let hc = that.$refs.warnBox.offsetHeight;
            that.scrollerHeight = hc - 85 + "px";
            let chart = echarts.init(document.getElementById("warnChart"));
            // 获取pie数据
            console.log(that.getDayList);
            let getList = that.getDayList;
            let arr = [];
            for (let i = 0; i < getList.length; i++) {
              let gl = getList[i].values;
              for (let j = 0; j < gl.length; j++) {
                if (gl[j].date == that.checkDate) {
                  arr.push({
                    name: getList[i].name,
                    value: gl[j].value,
                    itemStyle: { color: that.setColorList[i] },
                  });
                }
              }
            }
            that.setOptionFun(chart, arr);
          }else{
            let hc = that.$refs.warnBox.offsetHeight;
            that.scrollerHeight = hc - 85 + "px";
            let chart = echarts.init(document.getElementById("warnChart"));
            getEquipStatisticByModel({
              type: that.navType,
              tab: that.tabType,
              date: params.name,
              model: that.selectType == ''?'':that.equipTypeList[that.selectType+1].name
            }).then((res) => {
              console.log(res)
              let set = res.data.content.dataMap
              let arr = []
              let setA = []
              for(let key  in set){
                console.log(key + '---' + set[key])
                arr.push({
                  name: key,
                  value: set[key],
                  // itemStyle: { color: that.setColorList[i] },
                });
              }
              for(let i=0;i<arr.length;i++){
                setA.push({
                  name: arr[i].name,
                  value: arr[i].value,
                  itemStyle: { color: that.setColorList[i] },
                })
              }
              that.setOptionFun(chart, setA);
            })
          }
          
          
          that.gifShow = false
        }, 1000);
      });
    });
  },
  methods: {
    fetchDtList,
    // 接口获取饼图信息
    goToEquipInfo(e,t){
      this.$router.push({name:'EquipmentInfo',params:{
        'code': e,
        'typeName': t,
        'inArrow':'digitization',
        index: this.tabType,
      }})
    },
    typeChange(){
      console.log(this.selectType)
      let tab = this.tabType;
      let unit1 =''
      if (tab == 0) {
          unit1 = "L";
        } else if (tab == 1) {
          unit1 = "H";
        } else if (tab == 2) {
          unit1 = "km";
        }
      let r = []
      if(this.selectType == ''){
        r = JSON.parse(JSON.stringify(this.getDayList))
      }else{
        r.push(this.getDayList[this.selectType-1])
      }
      
      let st = this.selectType == ''?'all':'one'
      console.log(st)
      this.dayInfoSet(r, 'equip_model', unit1, tab, st);
    },
    sortChange(e) {
      this.sortCode = e;
      let list = [];
      let unit1 = "";
      let unit2 = "";

      let tab = this.tabType;
      if (tab == 0) {
        unit1 = "L";
        unit2 = "L/H";
      } else if (tab == 1) {
        unit1 = "H";
        unit2 = "%";
      } else if (tab == 2) {
        unit1 = "km";
        unit2 = "km";
      }
      if (e == 2) {
        list = JSON.parse(JSON.stringify(this.sortList));
        list.reverse();
      } else {
        list = this.sortList;
      }
      this.rankBefore(list, unit1, unit2, tab);
    },
    closeBox() {
      this.warnShow = false;
      this.gifShow = true
    },
    apiIsA(corpCode, type) {
      getEquipCountStatistics({
        corpCode: corpCode,
        type: type,
      }).then((r) => {
        console.log(r);
        // this.list_1 = r.data.content
        //饼图
        this.initBefore(r);
      });
    },
    // 接口获取排行榜信息
    apiIsB(tab, type, sort, mode) {
      getRank({
        tab: tab,
        type: type,
        sort: sort,
        mode: mode,
      }).then((r) => {
        console.log(r);
        let unit1 = "";
        let unit2 = "";
        if (tab == 0) {
          unit1 = "L";
          unit2 = "L/H";
        } else if (tab == 1) {
          unit1 = "H";
          unit2 = "%";
        } else if (tab == 2) {
          unit1 = "km";
          unit2 = "km";
        }
        this.sortCode = 1;
        let res = r.data.content.dataList;
        this.sortList = res;
        this.rankBefore(res, unit1, unit2, tab);
      });
    },
    // 接口获取每日油耗
    apiIsC(tab, type, startTime, endTime, groupBy) {
      getDay({
        tab: tab,
        type: type,
        startTime: startTime,
        endTime: endTime,
        groupBy: groupBy,
      }).then((r) => {
        console.log(r);
        let unit1 = "";
        if (tab == 0) {
          unit1 = "L";
        } else if (tab == 1) {
          unit1 = "H";
        } else if (tab == 2) {
          unit1 = "KM";
        }
        this.getDayList = r.data.content.info.dayOilVoList;
        this.warningList = r.data.content.info.dateWarningList;
        this.dateWarningMap = r.data.content.info.dateWarningMap;
        let list = r.data.content.info.dayOilVoList
        let arr = [{
          id: '',
          name: '全部'
        }]
        for(let i=0;i<list.length;i++){
          let setObj = {
            id: i+1,
            name: list[i].name
          }
          arr.push(setObj)
        }
        this.equipTypeList = arr
        this.selectType = ''
        this.dayInfoSet(this.getDayList, groupBy, unit1, tab, 'all');
      });
    },
    // 接口获取每日分析
    apiIsD(tab, type, startTime, endTime, groupBy) {
      getDayAnalysis({
        tab: tab,
        type: type,
        startTime: startTime,
        endTime: endTime,
        groupBy: groupBy,
      }).then((r) => {
        console.log(r);
        // if (groupBy == "equip_detail_type") {
        //   this.setAnalysisA = r.data.content.info;
        // } else {
          this.setAnalysisB = r.data.content.info;
          console.log(this.setAnalysisB);
        // }
      });
    },
    getDayInfo() {
      console.log(this.value2);
      this.loading = true
      if (this.value2) {
        let startTime = dateFormat(this.value2[0], "YYYY-MM-DD");
        let endTime = dateFormat(this.value2[1], "YYYY-MM-DD");
        // this.apiIsC(
        //   this.tabType,
        //   this.navType,
        //   startTime,
        //   endTime,
        //   "equip_detail_type"
        // );
        this.apiIsC(
          this.tabType,
          this.navType,
          startTime,
          endTime,
          "equip_model"
        );
        // this.apiIsD(
        //   this.tabType,
        //   this.navType,
        //   startTime,
        //   endTime,
        //   "equip_detail_type"
        // );
        this.apiIsD(
          this.tabType,
          this.navType,
          startTime,
          endTime,
          "equip_model"
        );
      }
    },
    doSearch: function () {
      this.search.tab = this.tabType;
      this.search.type = this.navType;
      this.getDataList(this.search, { listKey: "list" });
    },

    navTypeChange(e) {
      this.value2 = [];
      // this.typeName = e == 2 ? "摊铺机" : "压路机";
      switch (e) {
        case 1:
          this.typeName = "压路机";
          break;
        case 2:
          this.typeName = "摊铺机";
          break;
        case 35:
          this.typeName = "铣刨机";
          break;
      }
      let corpCode = localStorage.getItem("corpCode");
      this.navType = e;
      this.periodOrder = 0;
      this.period = 2;
      this.apiIsA(corpCode, e);
      this.apiIsB(this.tabType, e, this.periodOrder, this.period);
      // this.apiIsC(
      //   this.tabType,
      //   this.navType,
      //   this.startTime,
      //   this.endTime,
      //   "equip_detail_type"
      // );
      this.apiIsC(
        this.tabType,
        this.navType,
        this.startTime,
        this.endTime,
        "equip_model"
      );
      // this.apiIsD(
      //   this.tabType,
      //   this.navType,
      //   this.startTime,
      //   this.endTime,
      //   "equip_detail_type"
      // );
      this.apiIsD(
        this.tabType,
        this.navType,
        this.startTime,
        this.endTime,
        "equip_model"
      );
      this.search.pageNo = 1;
      this.doSearch();
    },
    tabTypeChange(e, t) {
      this.value2 = [];
      this.tabType = e;
      this.typeChangeText = t;
      this.periodOrder = 0;
      this.period = 2;
      switch (e) {
        case 0:
          this.unit = "L";
          break;
        case 1:
          this.unit = "H";
          break;
        case 2:
          this.unit = "km";
          break;
      }
      this.loading = true

      this.apiIsB(this.tabType, this.navType, this.periodOrder, this.period);
      // this.apiIsC(
      //   this.tabType,
      //   this.navType,
      //   this.startTime,
      //   this.endTime,
      //   "equip_detail_type"
      // );
      this.apiIsC(
        this.tabType,
        this.navType,
        this.startTime,
        this.endTime,
        "equip_model"
      );
      // this.apiIsD(
      //   this.tabType,
      //   this.navType,
      //   this.startTime,
      //   this.endTime,
      //   "equip_detail_type"
      // );
      this.apiIsD(
        this.tabType,
        this.navType,
        this.startTime,
        this.endTime,
        "equip_model"
      );
      this.search.pageNo = 1;
      this.search.tab = this.tabType;
      this.doSearch();
    },
    periodChange() {
      console.log(this.period);
      this.apiIsB(this.tabType, this.navType, this.periodOrder, this.period);
    },
    periodChangeOrder() {
      console.log(this.periodOrder);
      this.apiIsB(this.tabType, this.navType, this.periodOrder, this.period);
    },
    compare(property) {
      return function (a, b) {
        var value1 = a[property];
        var value2 = b[property];
        return value1 - value2;
      };
    },
    initBefore(r) {
      let listA = r.data.content[0];
      let listB = r.data.content[1];
      let listC = r.data.content[2];
      let arrA = [];
      let arrB = [];
      let arrC = [];
      for (let i = 0; i < listA.length; i++) {
        arrA.push({
          value: listA[i].count,
          name: listA[i].name,
          itemStyle: { color: this.setColorList[i] },
        });
      }
      for (let i = 0; i < listB.length; i++) {
        arrB.push({
          value: listB[i].count,
          name: listB[i].name,
          itemStyle: { color: this.setColorList[i] },
        });
      }
      for (let i = 0; i < listC.length; i++) {
        arrC.push({
          value: listC[i].count,
          name: listC[i].name,
          itemStyle: { color: this.setColorList[i] },
        });
      }
      this.list_1 = arrA;
      this.list_2 = arrB;
      this.list_3 = arrC;

      this.initCharts();
    },
    rankBefore(r, u1, u2, tab) {
      const echarts = require("echarts");
      this.orderChart = echarts.init(document.getElementById("orderChart"));
      let getlist = r;
      let setList = [];
      for (let i = 0; i < getlist.length; i++) {
        setList.push({
          name: getlist[i].name,
          allOil: getlist[i].values[0],
          hourOil: getlist[i].values[1],
        });
      }
      //获取总油耗排序
      let list = JSON.parse(JSON.stringify(setList));
      let allList = list;
      console.log(allList);
      let xAxisData = [];
      let yAxisData1 = [];
      let yAxisData2 = [];
      for (let i = 0; i < allList.length; i++) {
        xAxisData.push(allList[i].name);
        yAxisData1.push(allList[i].allOil);
        yAxisData2.push(allList[i].hourOil);
      }
      let endCode =
        allList.length < 9 ? 100 : Math.floor((9 * 100) / allList.length);
      let setOption = this.getChartOption(
        xAxisData,
        yAxisData1,
        yAxisData2,
        endCode,
        u1,
        u2,
        tab
      );
      this.orderChart.clear();
      this.orderChart.setOption(setOption);
    },
    dayInfoSet(r, groupBy, unit, tab, gt) {
      //每日油耗chart
      const echarts = require("echarts");
      if (groupBy == "equip_detail_type") {
        this.hourEquipChart = echarts.init(
          document.getElementById("hourEquipChart")
        );
      } else {
        this.hourEquipTypeChart = echarts.init(
          document.getElementById("hourEquipTypeChart")
        );
      }
      let that = this
      console.log(r)
      let hourList =  gt == 'one'?r:r
      let series = [];
      let legend = [];
      let xData = [];
      let yData = [];
      let yData1 = [];
      let endCodeHour = "";
      let yAxistr = "";
      // let yAxisData1 = []
      // let yAxisData2 = []
      for (let i = 0; i < hourList.length; i++) {
        let arr = hourList[i].values;
        legend.push(hourList[i].name);
        endCodeHour = arr.length < 9 ? 100 : Math.floor((9 * 100) / arr.length);
        yData = [];
        yData1 = [];
        for (let j = 0; j < arr.length; j++) {
          if (i == 0) {
            xData.push(arr[j].date);
          }
          yData.push(arr[j].value);
          if (tab == 0) {
            yData1.push(arr[j].hourValue);
          }
        }
        if(gt == 'one'){
          console.log('joinOne')
          if (tab == 0) {
            series.push(
              {
                name: r[0].name + '(油耗)',
                type: "bar",
                barWidth: 10,
                data: yData,
              },
              {
                name: r[0].name + '(每小时油耗)',
                type: "bar",
                barWidth: 10,
                yAxisIndex: 1,
                data: yData1,
              },
            );
          } else {
            series.push({
              name: hourList[i].name,
              type: "bar",
              stack: "total",
              label: { show: false },
              emphasis: { focus: "series" },
              barWidth: 10,
              data: yData,
            });
          }
        }else{
          console.log('joinAll')
          if (tab == 0) {
            series.push(
              {
                name: hourList[i].name,
                type: "bar",
                stack: "total1",
                label: { show: false, position: "insideRight" },
                emphasis: { focus: "series" },
                barWidth: 10,
                data: yData,
              },
              {
                name: hourList[i].name,
                type: "bar",
                stack: "total",
                label: { show: false, position: "insideLeft" },
                emphasis: { focus: "series" },
                barWidth: 10,
                yAxisIndex: 1,
                data: yData1,
              }
            );
          } else {
            series.push({
              name: hourList[i].name,
              type: "bar",
              stack: "total",
              label: { show: false },
              emphasis: { focus: "series" },
              barWidth: 10,
              data: yData,
            });
          }
        }
        
      }
      if (tab == 0) {
        yAxistr = [
          {
            type: "value",
            name: unit,
            splitLine: {
              show: true,
              lineStyle: {
                color: "#F0F0F0",
              },
            },
            axisLabel: {
              lineStyle: {
                color: "#8C8C8C",
              },
              formatter: "{value}" + "L",
            },
            axisLine: {
              show: false,
              lineStyle: {
                color: "#878787",
              },
            },
            axisTick: {
              show: false,
            },
          },
          {
            type: "value",
            name: "L/H",
            // min: 0,s
            splitLine: {
              show: true,
              lineStyle: {
                color: "#F0F0F0",
              },
            },
            axisLabel: {
              lineStyle: {
                color: "#8C8C8C",
              },
              formatter: "{value}",
            },
            axisLine: {
              show: false,
              lineStyle: {
                color: "#878787",
              },
            },
            axisTick: {
              show: false,
            },
          },
        ];
      } else {
        yAxistr = {
          type: "value",
          name: unit,
          splitLine: {
            show: true,
            lineStyle: {
              color: "#F0F0F0",
            },
          },
          axisLabel: {
            lineStyle: {
              color: "#8C8C8C",
            },
            formatter: "{value}",
          },
          axisLine: {
            show: false,
            lineStyle: {
              color: "#878787",
            },
          },
          axisTick: {
            show: false,
          },
        };
      }
      let hourOption = {
        color: this.setColorList,
        tooltip:
          tab == 0
            ? {
                trigger: "axis",
                axisPointer: {
                  type: "cross",
                  crossStyle: {
                    color: "#999",
                  },
                },
                formatter: function (datas) {
                  console.log(datas);
                  let res = "";
                  for (let i = 0; i < datas.length; i++) {
                    let code = datas[i].seriesId.substr(
                      datas[i].seriesId.length - 1,
                      1
                    );
                    let str = ''
                    if(gt == 'all'){
                      str = code == 0 ? "(油耗)" : "(每小时油耗)";
                    }
                    res +=
                      datas[i].seriesName +
                      str +
                      ":" +
                      datas[i].value +
                      "<br/>";
                  }
                  return res;
                },
              }
            : {
                trigger: "axis",
                axisPointer: {
                  type: "cross",
                  crossStyle: {
                    color: "#999",
                  },
                },
              },
        legend: {
          data: legend,
          textStyle: {
            color: "#595959",
            fontSize: 12,
          },
          right: 80,
        },
        grid: {
          left: 50,
          right: 50,
        },
        xAxis: {
          type: "category",
          axisLabel: {
            // color: "	#FF1493",
            // color: function(value,index){
            //   console.log(index,value)
            //   let list = that.warningList
            //   let color = ''
            //   for(let i=0;i<list.length;i++){
            //     if(value == list[i].date){
            //       // if(list[i].hasWarning)
            //       color = list[i].hasWarning?'#ff0000':'#8C8C8C'
            //     }
            //   }
            //   return color
            // },
            formatter: function(value){
              let list = []
              if(that.selectType == ''){
                list = that.warningList
              }else{
                let gIndex = that.equipTypeList[that.selectType].name
                list = that.dateWarningMap[gIndex]
                console.log(list)
              }
              for(let i=0;i<list.length;i++){
                if(value == list[i].date){
                  if(list[i].hasWarning){
                    return '{set|' + value + '}'
                  }else{
                    return '{old|' + value + '}'
                  }
                }
              }
            },
            rich: {
                set: {
                  color: '#ffffff',
                  backgroundColor: '#ff0000',
                  lineHeight: 16,
                  height: 16,
                  verticalAlign: 'bottom',
                  padding: [0,3,0,3],
                  borderRadius: 3,
                  fontSize: 12,
                },
                old:{
                  color: '#8C8C8C',
                  fontSize: 12,
                }
            },
          },
          axisPointer: {
            type: "shadow",
          },
          axisTick: {
            show: false,
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: "#000000",
            },
          },
          data: xData,
        },
        yAxis: yAxistr,
        dataZoom: [
          {
            type: "slider",
            show: true,
            realtime: true,
            start: 0,
            end: endCodeHour,
            handleSize: "5%",
            height: 5,
            handleStyle: {
              borderWidth: 0,
            },
            bottom: "10",
            borderColor: "#E5E5E5",
            fillerColor: "#E5E5E5",
          },
          {
            type: "inside",
            xAxisIndex: [0],
          },
          {
            type: "slider",
            yAxisIndex: [0],
            show: false,
            zoomLock: true,
          },
        ],
        series: series,
      };
      if (groupBy == "equip_detail_type") {
        this.hourEquipChart.clear();
        this.hourEquipChart.setOption(hourOption);
      } else {
        // let that = this;
        this.hourEquipTypeChart.clear();
        this.hourEquipTypeChart.setOption(hourOption);
        
      }
      this.loading = false
    },
    initCharts() {
      const echarts = require("echarts");
      let chart_1 = echarts.init(document.getElementById("infoItemChart_1"));
      let chart_2 = echarts.init(document.getElementById("infoItemChart_2"));
      let chart_3 = echarts.init(document.getElementById("infoItemChart_3"));

      this.setOptionFun(chart_1, this.list_1);
      this.setOptionFun(chart_2, this.list_2);
      this.setOptionFun(chart_3, this.list_3);

      //获取option
    },
    setOptionFun(e, data) {
      let option = {
        tooltip: {
          trigger: "item",
        },
        legend: {
          bottom: "0%",
          left: "center",
        },
        series: [
          {
            name: "设备信息",
            type: "pie",
            radius: ["0%", "60%"],
            avoidLabelOverlap: false,
            center: ["50%", "40%"],
            itemStyle: {
              borderRadius: 0,
              borderColor: "#fff",
              borderWidth: 2,
            },
            label: {
              show: false,
              position: "center",
            },
            emphasis: {
              label: {
                show: true,
                fontSize: "16",
                fontWeight: "bold",
                color: "#000000",
              },
            },
            labelLine: {
              show: false,
            },
            data: data,
          },
        ],
      };
      e.setOption(option);
    },

    getChartOption(xAxisData, yAxisData1, yAxisData2, endCode, u1, u2, tab) {
      let nameData = [];
      tab =tab * 1
      switch (tab) {
        case 0:
          nameData = ["总油耗", "每小时油耗"];
          break;
        case 1:
          nameData = ["开机时长", "利用率"];
          break;
        case 2:
          nameData = ["行驶里程"];
          break;
      }
      console.log(tab);
      console.log(u1);
      console.log(u2);
      console.log(nameData);
      let option = "";
      if (tab != 2) {
        option = {
          color: ["#FFA940", "#597EF7"],
          grid: {
            left: 50,
            right: 50,
          },
          tooltip: {
            trigger: "axis",
            axisPointer: {
              type: "cross",
              crossStyle: {
                color: "#999",
              },
            },
          },
          legend: {
            data: nameData,
            textStyle: {
              color: "#595959",
              fontSize: 12,
            },
            right: 20,
          },
          xAxis: [
            {
              type: "category",
              axisLabel: {
                color: "#8C8C8C",
              },
              data: xAxisData,
              axisPointer: {
                type: "shadow",
              },
              axisTick: {
                show: false,
              },
              axisLine: {
                show: true,
                lineStyle: {
                  color: "#000000",
                },
              },
            },
          ],
          yAxis: [
            {
              type: "value",
              name: u1,
              // interval: '',
              splitLine: {
                show: true,
                lineStyle: {
                  color: "#F0F0F0",
                },
              },
              axisLabel: {
                lineStyle: {
                  color: "#8C8C8C",
                },
                formatter: "{value}",
              },
              axisLine: {
                show: false,
                lineStyle: {
                  color: "#878787",
                },
              },
              axisTick: {
                show: false,
              },
            },
            {
              type: "value",
              name: u2,
              min: 0,
              // interval: 2,
              splitLine: {
                show: false,
              },
              axisLabel: {
                lineStyle: {
                  color: "#878787",
                },
                formatter: "{value}",
              },
              axisLine: {
                show: false,
                lineStyle: {
                  color: "#878787",
                },
              },
              axisTick: {
                show: false,
              },
            },
          ],
          dataZoom: [
            {
              type: "slider",
              show: true,
              realtime: true,
              start: 0,
              end: endCode,
              handleSize: "5%",
              height: 5,
              handleStyle: {
                borderWidth: 0,
              },
              bottom: "10",
              borderColor: "#E5E5E5",
              fillerColor: "#E5E5E5",
            },
            {
              type: "inside",
              xAxisIndex: [0],
            },
            {
              type: "slider",
              yAxisIndex: [0],
              show: false,
              zoomLock: true,
            },
          ],
          series: [
            {
              name: nameData[0],
              type: "bar",
              barWidth: 10,
              data: yAxisData1,
            },
            {
              name: nameData[1],
              type: "bar",
              barWidth: 10,
              yAxisIndex: 1,
              data: yAxisData2,
            },
          ],
        };
      } else {
        option = {
          color: ["#FFA940", "#597EF7"],
          grid: {
            left: 50,
            right: 50,
          },
          tooltip: {
            trigger: "axis",
            axisPointer: {
              type: "cross",
              crossStyle: {
                color: "#999",
              },
            },
          },
          legend: {
            data: nameData,
            textStyle: {
              color: "#595959",
              fontSize: 12,
            },
            right: 20,
          },
          xAxis: [
            {
              type: "category",
              axisLabel: {
                color: "#8C8C8C",
              },
              data: xAxisData,
              axisPointer: {
                type: "shadow",
              },
              axisTick: {
                show: false,
              },
              axisLine: {
                show: true,
                lineStyle: {
                  color: "#000000",
                },
              },
            },
          ],
          yAxis: [
            {
              type: "value",
              name: u1,
              // interval: '',
              splitLine: {
                show: true,
                lineStyle: {
                  color: "#F0F0F0",
                },
              },
              axisLabel: {
                lineStyle: {
                  color: "#8C8C8C",
                },
                formatter: "{value}",
              },
              axisLine: {
                show: false,
                lineStyle: {
                  color: "#878787",
                },
              },
              axisTick: {
                show: false,
              },
            },
          ],
          dataZoom: [
            {
              type: "slider",
              show: true,
              realtime: true,
              start: 0,
              end: endCode,
              handleSize: "5%",
              height: 5,
              handleStyle: {
                borderWidth: 0,
              },
              bottom: "10",
              borderColor: "#E5E5E5",
              fillerColor: "#E5E5E5",
            },
            {
              type: "inside",
              xAxisIndex: [0],
            },
            {
              type: "slider",
              yAxisIndex: [0],
              show: false,
              zoomLock: true,
            },
          ],
          series: [
            {
              name: nameData[0],
              type: "bar",
              barWidth: 10,
              data: yAxisData1,
            },
          ],
        };
      }

      return option;
    },

    // getAllInfo: function () {
    //   const echarts = require("echarts");
    //   let params = {
    //     mode: this.period,
    //   };
    //   getEquipWorkTime(params).then((res) => {
    //     console.log(res);
    //     this.totalNum = res.data.content.info.totalNum
    //     this.pieChart = echarts.init(document.getElementById("pieChart"));
    //     let getMap = res.data.content.info.stateMap;
    //     let setData = [
    //       { value: 0, name: "离线" },
    //       { value: 0, name: "空闲" },
    //       { value: 0, name: "作业中" },
    //       { value: 0, name: "紧停" },
    //       { value: 0, name: "暂停" },
    //     ];
    //     for (let key in getMap) {
    //       console.log(key);
    //       setData[key].value = getMap[key];
    //     }
    //     let option = {
    //       tooltip: {
    //         trigger: "item",
    //         formatter: "{a} <br/>{b}: {c} ({d}%)",
    //       },
    //       legend: {
    //         // orient: 'vertical',
    //         bottom: 10,
    //         left: 50,
    //         itemHeight: 10,
    //         itemWidth: 10,
    //         data: ["作业中", "空闲", "离线", "紧停", "暂停"],
    //       },
    //       series: [
    //         {
    //           name: "设备数量",
    //           type: "pie",
    //           radius: ["42%", "60%"],
    //           avoidLabelOverlap: false,
    //           label: {
    //             show: false,
    //             position: "center",
    //           },
    //           emphasis: {
    //             label: {
    //               show: false,
    //               fontSize: "30",
    //               fontWeight: "bold",
    //             },
    //           },
    //           labelLine: {
    //             show: false,
    //           },
    //           itemStyle: {
    //             normal: {
    //               color: function (params) {
    //                 let colorList = [
    //                   "#657797",
    //                   "#F2AF4A",
    //                   "#409EFF",
    //                   "#FFB6C1",
    //                   "#FF1493",
    //                 ];
    //                 return colorList[params.dataIndex];
    //               },
    //             },
    //           },
    //           data: setData,
    //         },
    //       ],
    //     };
    //     this.pieChart.setOption(option);

    //     let getData = res.data.content.info;
    //     const xAxisListLine = getData.data.map((item) => item.name);
    //     let colorListBasic = [
    //       "#657797",
    //       "#F2AF4A",
    //       "#409EFF",
    //       "#FFB6C1",
    //       "#FF1493",
    //     ];
    //     let barColorList = []
    //     for(let i=0;i<getData.data.length;i++){
    //       barColorList.push(colorListBasic[getData.data[i].values[2]])
    //     }
    //     let barName= ''
    //     console.log(this.period)
    //     if(this.period == 0){
    //       barName = '每日施工时间'
    //     }else if(this.period == 1){
    //       barName = '每周施工时间'
    //     }else if(this.period == 2){
    //       barName = '每月施工时间'
    //     }
    //     let seriesLine = [
    //       {
    //         name: barName,
    //         type: "bar",
    //         itemStyle: {
    //             normal: {
    //                 color: function(params) {
    //                     // 给出颜色组
    //                     var colorList = barColorList;
    //                     return colorList[params.dataIndex]
    //                 },
    //             }
    //         },
    //         barWidth: 10,
    //         data: getData.data.map((item) => {
    //           return item.values[0].toFixed(1);
    //         }),
    //       },
    //       {
    //         name: "设备利用率",
    //         type: "line",
    //         yAxisIndex: 1,
    //         data: getData.data.map((item) => {
    //           return (item.values[1] * 100).toFixed(1);
    //         }),
    //       },
    //     ];
    //     this.lineChartOption = {
    //       dataZoomEnd: Math.min(100, Math.ceil((8 / xAxisListLine.length) * 100)),
    //         legend: {
    //           data: ['',"设备利用率"],
    //           textStyle: {
    //             color: "#555555",
    //             fontSize: 12,
    //           },
    //           top: 0,
    //           right: 50,
    //           itemHeight: 10,
    //           itemWidth: 10,
    //         },
    //         grid: {
    //           left: 120,
    //           right: 60,
    //           top: 60,
    //           bottom: 50,
    //         },
    //         xAxis: [
    //           {
    //             type: "category",
    //             data: xAxisListLine,
    //             splitLine:{
    //               show:false
    //             },
    //             axisLabel:{
    //               lineStyle:{
    //                 color: '#878787'
    //               }
    //             },
    //             axisLine:{
    //               lineStyle:{
    //                 color:'#878787'
    //               }
    //             },
    //             axisTick:{
    //               show:false
    //             }
    //           },
    //         ],
    //         yAxis: [
    //           {
    //               type: 'value',
    //               name: '(H)',
    //               interval: 25,
    //               splitLine:{
    //                 show:false
    //               },
    //               axisLabel:{
    //                 lineStyle:{
    //                   color: '#878787'
    //                 },
    //                 // formatter: '{value} H'
    //               },
    //               axisLine:{
    //                 lineStyle:{
    //                   color:'#878787'
    //                 }
    //               },
    //               axisTick:{
    //                 show:false
    //               }
    //           },
    //           {
    //               type: 'value',
    //               name: '',
    //               interval: 25,
    //               splitLine:{
    //                 show:false
    //               },
    //               axisLabel:{
    //                 lineStyle:{
    //                   color: '#878787'
    //                 },
    //                 formatter: '{value} %'
    //               },
    //               axisLine:{
    //                 lineStyle:{
    //                   color:'#878787'
    //                 }
    //               },
    //               axisTick:{
    //                 show:false
    //               }
    //           }
    //         ],
    //         series: seriesLine,
    //     }
    //   });
    //   getEquipOilRank(params).then((res) => {
    //     console.log(res);
    //     let getData = res.data.content.info.data;
    //     getData.reverse()
    //     this.oilChart = echarts.init(document.getElementById("oilChart"));
    //     const yAxisList = getData.map((item) => item.name);
    //     const series = {
    //       name: "油耗",
    //       type: "bar",
    //       barWidth: 10,
    //       data: getData.map((item) => {
    //         return item.value.toFixed(2);
    //       }),
    //       itemStyle: {
    //         normal: {
    //           color: "#409EFF",
    //         },
    //       },
    //     };
    //     let option = {
    //       legend: {
    //         data: ["油耗"],
    //         textStyle: {
    //           color: "#555555",
    //           fontSize: 12,
    //         },
    //         top: 0,
    //         right: 50,
    //         itemHeight: 10,
    //         itemWidth: 10,
    //       },
    //       tooltip: {
    //         trigger: "axis",
    //         axisPointer: {
    //           type: "cross",
    //           crossStyle: {
    //             color: "#999",
    //           },
    //         },
    //         // formatter:function(params){
    //         //   console.log(params)
    //         //   console.log(params[0].dataIndex)
    //         //   let status = ''
    //         //   if(statusArr[params[0].dataIndex] == 1){
    //         //     status = '按时完成'
    //         //   }else if(statusArr[params[0].dataIndex] == 2){
    //         //     status = '超时完成'
    //         //   }else if(statusArr[params[0].dataIndex] == 3){
    //         //     status = '未完成'
    //         //   }
    //         //   let str = params[0].name + '</br>'
    //         //   str = str + '施工时长:' + params[0].data + 'H' + '</br>'
    //         //   str = str + '作业状态:' + status
    //         //   return str
    //         // }
    //       },
    //       grid: {
    //         left: 120,
    //         right: 60,
    //         top: 60,
    //         bottom: 40,
    //       },
    //       xAxis: {
    //         type: "value",
    //         name: "(L)",
    //         splitLine: {
    //           show: false,
    //         },
    //         axisLabel: {
    //           color: "#878787",
    //           fontSize: 10,
    //           // formatter: function(value){
    //           //   return value + 'L'
    //           // }
    //         },
    //         axisLine: {
    //           lineStyle: {
    //             color: "#878787",
    //           },
    //         },
    //         axisTick: {
    //           show: false,
    //         },
    //         position: "top",
    //       },

    //       yAxis: {
    //         type: "category",

    //         nameTextStyle: {
    //           color: "#878787",
    //           fontSize: 10,
    //         },
    //         // interval: '',
    //         splitLine: {
    //           show: false,
    //           lineStyle: {
    //             color: ["#194793"],
    //           },
    //         },
    //         axisLabel: {
    //           color: "#878787",
    //           fontSize: 10,
    //         },
    //         axisLine: {
    //           show: true,
    //           lineStyle: {
    //             color: "#878787",
    //           },
    //         },
    //         axisTick: {
    //           show: false,
    //         },
    //         data: yAxisList,
    //       },
    //       dataZoom: [
    //         {
    //           type: "slider",
    //           show: true,
    //           realtime: false,
    //           start: 100,
    //           end: 65,
    //           width: 8,
    //           backgroundColor: "#e4e3e8",
    //           yAxisIndex: [0],
    //           top:'9%',
    //           left:20,
    //           handleSize: 0,
    //           showDetail: false,
    //           showDataShadow: false,
    //           handleStyle: {
    //             borderWidth: 0,
    //             color: "#c0c0c8",
    //           },
    //         },
    //         {
    //           type: "inside",
    //           xAxisIndex: [0],
    //           show: false,
    //           zoomLock: true,
    //         },
    //         {
    //           type: "inside",
    //           yAxisIndex: [0],
    //           show: false,
    //           zoomLock: true,
    //         },
    //       ],
    //       series: series,
    //     };
    //     this.oilChart.setOption(option);
    //     this.nodataShow=false
    //   });

    //   getEquipMileage(params).then((res) => {
    //     console.log(res);
    //     let getData = res.data.content.info;
    //     const xAxisList = getData.data.map((item) => item.name);
    //     const series = [
    //       {
    //         name: "摊铺机",
    //         type: "bar",
    //         barWidth: 10,
    //         data: getData.data.map((item) => {
    //           return (item.values[0] ).toFixed(1);
    //         }),
    //         itemStyle: {
    //           normal: {
    //             color: "#409EFF",
    //           },
    //         },
    //       },
    //       {
    //         name: "压路机",
    //         type: "bar",
    //         barWidth: 10,
    //         data: getData.data.map((item) => {
    //           return (item.values[1] ).toFixed(1);
    //         }),
    //         itemStyle: {
    //           normal: {
    //             color: "#F2AF4A",
    //           },
    //         },
    //       },
    //     ];
    //     this.config1 = {
    //       title: "",

    //       circleConfig: [
    //         {
    //           id: this.uuid(),
    //           title: "今日摊铺里程",
    //           color: "#4facf9",
    //           content: (getData.paverMeanMileage / 1000).toFixed(1),
    //           percent: (getData.paverMileage / 1000).toFixed(1),
    //           unit: "KM",
    //           name1: "今日摊铺里程",
    //           name2: "平均摊铺里程",
    //         },
    //         {
    //           id: this.uuid(),
    //           title: "今日碾压里程",
    //           color: "#f6c018",
    //           content: (getData.rollerMeanMileage / 1000).toFixed(1),
    //           percent: (getData.rollerMileage / 1000).toFixed(1),
    //           unit: "KM",
    //           name1: "今日碾压里程",
    //           name2: "平均碾压里程",
    //         },
    //       ],
    //       chartOption: Object.assign(
    //         {},
    //         {
    //           dataZoomEnd: Math.min(
    //             100,
    //             Math.ceil((8 / xAxisList.length) * 100)
    //           ),
    //           legend: {
    //             data: ["摊铺机", "压路机"],
    //             top: 0,
    //             right: 30,
    //             itemHeight: 10,
    //             itemWidth: 10,
    //           },
    //           grid: {
    //             bottom: 40,
    //             top: 30,
    //             left: 70
    //           },
    //           xAxis: [
    //             {
    //               type: "category",
    //               data: xAxisList,
    //               splitLine: {
    //                 show: false,
    //               },
    //               axisLabel: {
    //                 lineStyle: {
    //                   color: "#878787",
    //                 },
    //               },
    //               axisLine: {
    //                 lineStyle: {
    //                   color: "#878787",
    //                 },
    //               },
    //               axisTick: {
    //                 show: false,
    //               },
    //             },
    //           ],
    //           yAxis: [
    //             {
    //               type: "value",
    //               name: "(KM)",
    //               // interval: '',
    //               splitLine: {
    //                 show: false,
    //               },
    //               axisLabel: {
    //                 lineStyle: {
    //                   color: "#878787",
    //                 },
    //                 // formatter: '{value} KM'
    //               },
    //               axisLine: {
    //                 lineStyle: {
    //                   color: "#878787",
    //                 },
    //               },
    //               axisTick: {
    //                 show: false,
    //               },
    //             },
    //           ],
    //           series: series,
    //         }
    //       ),
    //     };
    //   });

    //   getEquipOilConsumption(params).then((res) => {
    //     let getData = res.data.content.info;
    //     const xAxisList = getData.data.map((item) => item.name);
    //     const series = [
    //       {
    //         name: "摊铺机",
    //         type: "bar",
    //         barWidth: 10,
    //         data: getData.data.map((item) => {
    //           return (item.values[0]).toFixed(1);
    //         }),
    //         itemStyle: {
    //           normal: {
    //             color: "#409EFF",
    //           },
    //         },
    //       },
    //       {
    //         name: "压路机",
    //         type: "bar",
    //         barWidth: 10,
    //         data: getData.data.map((item) => {
    //           return (item.values[1]).toFixed(1);
    //         }),
    //         itemStyle: {
    //           normal: {
    //             color: "#F2AF4A",
    //           },
    //         },
    //       },
    //     ];
    //     this.config2 = {
    //       title: "",

    //       circleConfig: [
    //         {
    //           id: this.uuid(),
    //           title: "今日摊铺机油耗",
    //           color: "#4facf9",
    //           content: (getData.paverMeanOil / 1).toFixed(1),
    //           percent: (getData.paverOil / 1).toFixed(1),
    //           unit: "L",
    //           name1: "今日摊铺机油耗",
    //           name2: "平均摊铺机油耗",
    //         },
    //         {
    //           id: this.uuid(),
    //           title: "今日压路机油耗",
    //           color: "#f6c018",
    //           content: (getData.rollerMeanOil / 1).toFixed(1),
    //           percent: (getData.rollerOil / 1).toFixed(1),
    //           unit: "L",
    //           name1: "今日压路机油耗",
    //           name2: "平均压路机油耗",
    //         },
    //       ],
    //       chartOption: Object.assign(
    //         {},
    //         {
    //           dataZoomEnd: Math.min(
    //             100,
    //             Math.ceil((8 / xAxisList.length) * 100)
    //           ),
    //           legend: {
    //             data: ["摊铺机", "压路机"],
    //             top: 0,
    //             right: 50,
    //             itemHeight: 10,
    //             itemWidth: 10,
    //           },
    //           grid: {
    //             bottom: 40,
    //             top: 30,
    //             left: 60
    //           },
    //           xAxis: [
    //             {
    //               type: "category",
    //               data: xAxisList,
    //               splitLine: {
    //                 show: false,
    //               },
    //               axisLabel: {
    //                 lineStyle: {
    //                   color: "#878787",
    //                 },
    //               },
    //               axisLine: {
    //                 lineStyle: {
    //                   color: "#878787",
    //                 },
    //               },
    //               axisTick: {
    //                 show: false,
    //               },
    //             },
    //           ],
    //           yAxis: [
    //             {
    //               type: "value",
    //               name: "(L)",
    //               // interval: '',
    //               splitLine: {
    //                 show: false,
    //               },
    //               axisLabel: {
    //                 lineStyle: {
    //                   color: "#878787",
    //                 },
    //                 // formatter: '{value} KM'
    //               },
    //               axisLine: {
    //                 lineStyle: {
    //                   color: "#878787",
    //                 },
    //               },
    //               axisTick: {
    //                 show: false,
    //               },
    //             },
    //           ],
    //           series: series,
    //         }
    //       ),
    //     };
    //   });
    // },
    lookMore(e) {
      // console.log(this.tabType)
      this.$router.push({
        name: "EquipmentInfo",
        params: {
          code: e,
          typeName: this.typeName,
          inArrow: "digitization",
          index: this.tabType,
        },
      });
    },
    goBack: function () {
      this.$router.push({ name: 'EquipmentCenter' });
    },
  },
  components: {
    // ChartPanel,
    ElPageCover,
    DayInfo,
  },
};
</script>
<style lang="scss">
.digitizationCon{
  .el-dialog__body{
    padding: 0 !important;
  }
  .el-dialog {
    width: 960px !important;
}
}
.warnCon {
  .el-pagination__total {
    display: none !important;
  }
  .el-pagination__sizes {
    display: none !important;
  }
  .el-pagination__jump {
    display: none !important;
  }
  .pageBlock .el-pager .active {
    background-color: rgba(0, 0, 0, 0) !important;
    color: #f56c6c !important;
  }
  .el-pager li {
    background-color: rgba(0, 0, 0, 0) !important;
  }
  .btn-next {
    background-color: rgba(0, 0, 0, 0) !important;
    border: 1px solid rgba(0, 0, 0, 0) !important;
  }
  .btn-prev {
    background-color: rgba(0, 0, 0, 0) !important;
    border: 1px solid rgba(0, 0, 0, 0) !important;
  }
  .number {
    padding: 0 !important;
    margin: 0 !important;
  }
}
.hourCon {
  .el-range-separator {
    width: 10% !important;
  }
}
</style>
<style lang="scss" scoped="">
.digitizationCon {
  width: 1872px;
  min-height: 500px;
  border-radius: 2px;
  background: #ffffff;
  border: 1px solid #e5e5e5;
  margin: 0 auto;
  padding-top: 24px;
  padding-bottom: 24px;
  position: relative;
  .warnMask {
    height: 100%;
    width: 100%;
    background-color: rgba(0, 0, 0, 0.3);
    position: fixed;
    top: 0;
    left: 0;
    z-index: 100;
    
  }
  .warnBox {
    z-index: 101;
      width: 960px;
      min-height: 200px;
      max-height: 546px;
      // background: #ffffff;
      // box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.3);
      // border-radius: 2px;
      // position: fixed;
      // top: 50%;
      // left: 50%;
      // transform: translate(-50%, -50%);
      padding-top: 30px;
      padding-bottom: 30px;
      .gifShow{
        position: absolute;
        right: 50px;
      }
      .boxLeft {
        width: 320px;
        min-height: 320px;
        float: left;
        position: relative;
        .warnChart {
          width: 280px;
          height: 280px;
          position: absolute;
          top: 40%;
          left: 50%;
          transform: translate(-50%, -50%);
        }
      }
      .boxRight {
        width: 639px;
        height: auto;
        float: left;
        max-height: 450px;
        // overflow: hidden;
        overflow-y: auto;
        .warnInfoCon {
          width: 100%;
          height: auto;
          position: relative;
          margin-bottom: 48px;
          .numShow_1 {
            height: 24px;
            width: 24px;
            position: absolute;
            background-image: url("../../images/icon/num_1.png");
            background-size: 100% 100%;
            left: 20px;
            top: 0;
          }
          .numShow_2 {
            height: 24px;
            width: 24px;
            position: absolute;
            background-image: url("../../images/icon/num_2.png");
            background-size: 100% 100%;
            left: 20px;
            top: 0;
          }
          .warnInfoTitle {
            width: 100%;
            height: 22px;
            line-height: 22px;
            font-size: 16px;
            color: #333333;
            padding-left: 56px;
          }
          .warnInfoItem {
            width: 100%;
            height: auto;

            .infoItem {
              position: relative;
              width: 100%;
              padding-left: 56px;
              padding-right: 80px;
              min-height: 24px;
              line-height: 24px;
              color: #595959;
              font-size: 14px;
              margin-top: 24px;
              .clickToMore {
                color: #f56c6c;
                cursor: pointer;
              }
              .circle_1 {
                width: 10px;
                height: 10px;
                background: #ffffff;
                border: 2px solid #e6a23c;
                border-radius: 5px;
                position: absolute;
                top: 7px;
                left: 27px;
              }
              .circle_2 {
                width: 10px;
                height: 10px;
                background: #ffffff;
                border: 2px solid #8c8c8c;
                border-radius: 5px;
                position: absolute;
                top: 7px;
                left: 27px;
              }
            }
          }
        }
      }
      .warnTitle {
        display: inline-block;
        position: absolute;
        top: 15px;
        left: 20px;
        height: 24px;
        font-size: 18px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
        line-height: 24px;
      }
      .closeShow {
        display: inline-block;
        position: absolute;
        top: 16px;
        right: 23px;
        height: 24px;
        font-size: 24px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #888888;
        line-height: 24px;
        cursor: pointer;
      }
    }

  .digNav {
    width: 1824px;
    height: 48px;
    margin: 0 auto;
    background: #f5f5f5;
    border: 1px solid #f0f0f0;
    position: relative;
    padding-left: 138px;
    .navTitle {
      position: absolute;
      display: inline-block;
      height: 26px;
      line-height: 26px;
      color: #404040;
      font-size: 18px;
      left: 24px;
      top: 50%;
      transform: translateY(-50%);
      font-family: Noto Sans SC;
      font-weight: 600;
    }
    .navType_1 {
      height: 100%;
      width: 96px;
      // position: absolute;
      // top: 0;
      left: 138px;
      line-height: 48px;
      text-align: center;
      color: #404040;
      font-size: 16px;
      cursor: pointer;
      position: relative;
      float: left;
    }
    .navType_2 {
      height: 100%;
      width: 96px;
      // position: absolute;
      // top: 0;
      // left: 234px;
      line-height: 48px;
      text-align: center;
      color: #404040;
      font-size: 16px;
      cursor: pointer;
      float: left;
    }
    .navType_3 {
      height: 100%;
      width: 96px;
      // position: absolute;
      // top: 0;
      // left: 330px;
      line-height: 48px;
      text-align: center;
      color: #404040;
      font-size: 16px;
      cursor: pointer;
      float: left;
    }
    .navLine {
      width: 48px;
      height: 2px;
      background: #f56c6c;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      bottom: 0;
    }
    .navActive {
      background: #ffffff;
    }
  }
  .pieInfoCon {
    width: 1824px;
    height: 240px;
    margin: 0 auto;
    margin-top: 24px;
    display: flex;
    .pieInfoItem {
      flex: 1;
      position: relative;
      .infoItemChart {
        width: 296px;
        height: 240px;
        position: absolute;
        top: 0;
        left: 0;
      }
      .infoItemNum {
        width: 250px;
        min-height: 20px;
        max-height: 250px;
        overflow: auto;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        right: 65px;
        padding-right: 19px;
        .itemNumShow {
          width: 100%;
          height: 35px;
          margin-top: 8px;
          display: flex;
          .showCon1 {
            flex: 2;
            text-align: right;
            line-height: 35px;
            color: #595959;
            font-size: 16px;
          }
          .showCon2 {
            flex: 1;
            text-align: right;
            // line-height: 35px;
            color: #f56c6c;
            font-size: 24px;
          }
        }
      }
    }
  }
  .tabTypeCon {
    width: 100%;
    height: 32px;
    margin-top: 24px;
    position: relative;
    .tabTypeItem_1 {
      position: absolute;
      width: 100px;
      height: 32px;
      left: 24px;
      top: 0;
      -webkit-transform: skew(-20deg);
      -moz-transform: skew(-20deg);
      -o-transform: skew(-20deg);
      -ms-transform: skew(-20deg);
      transform: skew(-20deg);
      background: #feecea;
    }
    .tabTypeItem_2 {
      position: absolute;
      width: 128px;
      height: 32px;
      left: 136px;
      top: 0;
      -webkit-transform: skew(-20deg);
      -moz-transform: skew(-20deg);
      -o-transform: skew(-20deg);
      -ms-transform: skew(-20deg);
      transform: skew(-20deg);
      background: #feecea;
    }
    .tabTypeItem_3 {
      position: absolute;
      width: 128px;
      height: 32px;
      left: 276px;
      top: 0;
      -webkit-transform: skew(-20deg);
      -moz-transform: skew(-20deg);
      -o-transform: skew(-20deg);
      -ms-transform: skew(-20deg);
      transform: skew(-20deg);
      background: #feecea;
    }
    .tabTypeText_1 {
      position: absolute;
      width: 100px;
      height: 32px;
      left: 24px;
      top: 0;
      line-height: 32px;
      text-align: center;
      font-size: 14px;
      color: #f56c6c;
      cursor: pointer;
    }
    .tabTypeText_2 {
      position: absolute;
      width: 128px;
      height: 32px;
      left: 136px;
      top: 0;
      line-height: 32px;
      text-align: center;
      font-size: 14px;
      color: #f56c6c;
      cursor: pointer;
    }
    .tabTypeText_3 {
      position: absolute;
      width: 128px;
      height: 32px;
      left: 276px;
      top: 0;
      line-height: 32px;
      text-align: center;
      font-size: 14px;
      color: #f56c6c;
      cursor: pointer;
    }
    .tabTypeActive {
      background: #f56c6c;
    }
    .tabTypeTextActive {
      color: #fff;
    }
  }
  .hourCon {
    width: 1824px;
    height: 500px;
    margin: 0 auto;
    margin-top: 24px;
    position: relative;
    .fxCon {
      width: 592px;
      height: 416px;
      position: absolute;
      right: 0;
      top: 104px;
      border-radius: 2px;
      background: #ffffff;
      border: 1px solid #f0f0f0;
      .dayInfoContent {
        width: 544px;
        height: 320px;
        position: absolute;
        top: 72px;
        left: 24px;
      }
      .line {
        height: 16px;
        width: 4px;
        background-color: #fa0c28;
        position: absolute;
        top: 28px;
        left: 24px;
      }
      .lineText {
        height: 16px;
        line-height: 16px;
        font-size: 15px;
        color: #404040;
        position: absolute;
        top: 29px;
        left: 36px;
        font-weight: bold;
      }
    }
    .fxConT {
      width: 592px;
      height: 416px;
      position: absolute;
      right: 0;
      top: 104px;
      border-radius: 2px;
      background: #ffffff;
      border: 1px solid #f0f0f0;
      .dayInfoContent {
        width: 544px;
        height: 320px;
        position: absolute;
        top: 72px;
        left: 24px;
      }
      .line {
        height: 16px;
        width: 4px;
        background-color: #fa0c28;
        position: absolute;
        top: 28px;
        left: 24px;
      }
      .lineText {
        height: 16px;
        line-height: 16px;
        font-size: 15px;
        color: #404040;
        position: absolute;
        top: 29px;
        left: 36px;
        font-weight: bold;
      }
    }
    .hourEquipChart {
      width: 1208px;
      height: 416px;
      position: absolute;
      left: 0;
      top: 104px;
    }
    .hourEquipTypeChart {
      width: 1208px;
      height: 416px;
      position: absolute;
      left: 0;
      top: 104px;
    }
    .dateCheckCon {
      position: absolute;
      top: 44px;
      left: 40px;
    }
    .dateSelectCon {
      position: absolute;
      top: 44px;
      left: 570px;
    }
    .searchCon {
      width: 60px;
      height: 32px;
      position: absolute;
      top: 48px;
      left: 400px;
      line-height: 32px;
      text-align: center;
      background: #f56c6c;
      font-size: 14px;
      color: #fff;
      cursor: pointer;
    }

    .text_1 {
      display: inline-block;
      position: absolute;
      height: 20px;
      line-height: 20px;
      font-size: 14px;
      color: #595959;
      top: 54px;
      left: 0;
    }
    .text_2 {
      display: inline-block;
      position: absolute;
      height: 20px;
      line-height: 20px;
      font-size: 14px;
      color: #595959;
      top: 54px;
      left: 500px;
    }
  }
  .orderCon {
    width: 1824px;
    height: 592px;
    margin: 0 auto;
    margin-top: 24px;
    position: relative;
    .sortCon2 {
      width: 24px;
      height: 24px;
      background-image: url("../../images/icon/sort2.png");
      background-size: 100% 100%;
      position: absolute;
      left: 550px;
      top: 50px;
      cursor: pointer;
    }
    .sortCon1 {
      width: 24px;
      height: 24px;
      background-image: url("../../images/icon/sort1.png");
      background-size: 100% 100%;
      position: absolute;
      left: 550px;
      top: 50px;
      cursor: pointer;
    }
    .orderChart {
      width: 1208px;
      height: 500px;
      position: absolute;
      left: 0;
      bottom: 0;
      // background-color: rosybrown;
    }
    .warnCon {
      width: 592px;
      height: 500px;
      position: absolute;
      right: 0;
      bottom: 0;
      background: #feecea;
      .pageBlock {
        display: block;
        position: absolute;
        bottom: 10px;
        right: 0;
      }
      .warnItem {
        width: 544px;
        height: auto;
        position: absolute;
        top: 72px;
        left: 50%;
        transform: translateX(-50%);
        .warnItemInfo {
          width: 100%;
          height: 64px;
          margin-bottom: 12px;
          border-bottom: 1px solid rgba(245, 108, 108, 0.1);
          position: relative;
          .lookMore {
            display: inline-block;
            position: absolute;
            height: 24px;
            line-height: 24px;
            color: #f56c6c;
            font-size: 14px;
            top: 20px;
            right: 24px;
            cursor: pointer;
          }
          .right {
            border: solid #f56c6c;
            border-width: 0 1px 1px 0;
            display: inline-block;
            padding: 3px;
            transform: rotate(-45deg);
            -webkit-transform: rotate(-45deg);
            position: absolute;
            top: 28px;
            right: 15px;
          }
          .warnName {
            display: inline-block;
            position: absolute;
            height: 24px;
            line-height: 24px;
            color: #595959;
            font-size: 16px;
            top: 0;
            left: 0;
          }
          .warnInfo {
            display: inline-block;
            position: absolute;
            height: 24px;
            line-height: 24px;
            color: #595959;
            font-size: 16px;
            top: 28px;
            left: 0;
          }
        }
      }
      .line {
        height: 16px;
        width: 4px;
        background-color: #fa0c28;
        position: absolute;
        top: 28px;
        left: 24px;
      }
      .lineText {
        height: 16px;
        line-height: 16px;
        font-size: 15px;
        color: #404040;
        position: absolute;
        top: 29px;
        left: 36px;
        font-weight: bold;
      }
    }
    .text_1 {
      display: inline-block;
      position: absolute;
      height: 20px;
      line-height: 20px;
      font-size: 14px;
      color: #595959;
      top: 54px;
      left: 0;
    }
    .text_2 {
      display: inline-block;
      position: absolute;
      height: 20px;
      line-height: 20px;
      font-size: 14px;
      color: #595959;
      top: 54px;
      left: 272px;
    }
    .search-form-group {
      display: inline;
      position: absolute;
      top: 44px;
    }
    .search-form-group .group-label {
      margin-right: 15px;
      font-size: 14px;
    }
    .search-form-group-order {
      display: inline;
      position: absolute;
      top: 44px;
      left: 300px;
    }
    .search-form-group-order .group-label {
      margin-right: 15px;
      font-size: 14px;
    }
  }
  .line {
    height: 16px;
    width: 4px;
    background-color: #fa0c28;
    position: absolute;
    top: 0px;
    left: 0px;
  }
  .lineText {
    height: 16px;
    line-height: 16px;
    font-size: 15px;
    color: #222222;
    position: absolute;
    top: 1px;
    left: 13px;
    font-weight: bold;
  }
}
.goBack {
  position: fixed;
  right: 16px;
  top: 68px;
  z-index: 1000;
}
</style>